// $(document).ready(function(){
//   $(document).on('click','#filter--sidebarToggle', function(e) {
//     console.log('test')
//     e.preventDefault();
//     $(this).toggleClass("is--toogled");
//     $("#shopify-section-collection__main").toggleClass("has-sidebar-option");
//     $(".collection__content aside.sidebar-section").toggleClass("is_sidebar_show");
//     $(".side-overlay").toggleClass("is-show");
//     $("body").toggleClass("body-lock");
//   });
//   $('.side-overlay').click(function(){
//   	$('#filter--sidebarToggle').trigger('click');
//   });
// });

window.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', e => {
    let _this; 
    if (_this = e.target.closest('#filter--sidebarToggle')) {
      e.preventDefault();
      _this.classList.toggle('is--toogled');
      document.querySelector(".collection__content aside.sidebar-section")?.classList.toggle('is_sidebar_show');
      document.querySelector(".collection__content .collection__main")?.classList.toggle('is_sidebar_show');
      document.body.classList.toggle('body-sidebar-shown')
    } else if (_this = e.target.closest('.sidebar-close')) {
      document.querySelector(".collection__content aside.sidebar-section")?.classList.toggle('is_sidebar_show', false);
      document.querySelector(".collection__content .collection__main")?.classList.toggle('is_sidebar_show', false);
      document.body.classList.remove('body-sidebar-shown')
    }
  })
})
